import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CALL_OFF_SOURCE_LABEL_ENTRIES } from "../utils/callIns";
import type { ChangesSource } from "../utils/models";

// Shared by the Call-Ins report and the Last Call-Ins grid, which used to keep their own copies.
// SupportLine is still mapped because old rows have it.
// useCallback because callers put this in useMemo deps.
export const useCallOffSourceLabel = () => {
	const { t } = useTranslation();
	return useCallback(
		(source: ChangesSource | null | undefined): string => {
			const entry = CALL_OFF_SOURCE_LABEL_ENTRIES.find((e) => e.source === source);
			// DEFAULT: a row with no recorded source shows a blank cell, and a value newer than the frontend
			// enum shows verbatim — both are real data states, not missing input to fail on.
			return entry ? t(entry.translationKey) : (source ?? "");
		},
		[t],
	);
};
